import { Injectable } from '@angular/core';
import { select, Store } from '@ngrx/store';

import * as NotificationsActions from './notifications.actions';
import { NotificationsPartialState } from './notifications.reducer';
import {
  selectItems,
  selectLoaded,
  unreadCount,
} from './notifications.selectors';

@Injectable({
  providedIn: 'root',
})
export class NotificationsFacade {
  isLoaded$ = this.store.pipe(select(selectLoaded));

  items$ = this.store.pipe(select(selectItems));

  unreadCount$ = this.store.pipe(select(unreadCount));

  constructor(private store: Store<NotificationsPartialState>) {}

  getUserUnreadNotifications() {
    this.store.dispatch(NotificationsActions.getUserLatestNotifications());
  }

  subscribeUserNotifications() {
    this.store.dispatch(NotificationsActions.subscribeUserNotifications());
  }
}
